<template>
    <div>
        <div class="kit__utils__heading">
            <h5><span class="mr-3">{{this.$route.meta.title}}</span></h5>
        </div>
         <div class="card">
            <div class="card-header card-header-flex">
                <search v-bind="sentDataSearch"></search>
            </div>
            <div class="card-body">
                <div class="card-header card-header-flex">
                  <div class="d-flex flex-column justify-content-center mr-auto">
                    <h5 class="mb-0"></h5>
                  </div>
                  <div class="d-flex flex-column justify-content-center">
                    <a class="btn btn-primary" href="javascript: void(0);" @click="refreshData()"><i
                        class="fe fe-rotate-cw mr-1" /> รีเฟรช</a>
                  </div>
                </div>
                <a-table :columns="columns" :dataSource="data" rowKey='smsId' :scroll="{ x: 1500 }" :pagination="{defaultPageSize: 10, pageSizeOptions: ['10', '20', '30', '40', '50', '100'], showSizeChanger : true }">

                </a-table>
            </div>
        </div>
    </div>
</template>

<script>
import search from '@/components/system/table/search/sms'
import { mapGetters } from 'vuex'
import apiClient from '@/services/api'
import moment from 'moment'
import Swal from 'sweetalert2'
export default {

  computed: {
    ...mapGetters({
      getStartDate: 'getStartDate',
      getEndDate: 'getEndDate',
      getSelectOperator: 'getSelectOperator',
      getSelectBankSet: 'getSelectBankSet',
    }),
    sentDataSearch: function() {
      return {
        pageType: this.pageType,
      }
    },
  },
  watch: {
    getStartDate: function(val) {
      this.refreshData()
    },
    getSelectOperator: function() {
      this.refreshData()
    },
    getSelectBankSet: function() {
      this.refreshData()
    },
  },
  components: {
    search,
  },
  data() {
    return {
      data: [],
      pageType: 'sms',
      columns: [
        {
          title: 'ลำดับ',
          key: 'smsId',
          dataIndex: 'smsId',
        },
        {
          title: 'คู่ค้า',
          key: 'operatorName',
          dataIndex: 'operatorName',
          filters: [],
          onFilter: (value, record) => record.operatorName.toLowerCase().includes(value.toLowerCase()),
        },
        {
          title: 'ชุดบัญชี',
          key: 'bankSetName',
          dataIndex: 'bankSetName',
        },
        {
          title: 'Port',
          key: 'comPort',
          dataIndex: 'comPort',
        },
        {
          title: 'รหัสเครื่อง',
          key: 'serviceName',
          dataIndex: 'serviceName',
        },
        {
          title: 'ข้อความจาก',
          key: 'frombank',
          dataIndex: 'frombank',
        },
        {
          title: 'รายละเอียด',
          key: 'message',
          dataIndex: 'message',
          width: 250,
          onFilter: (value, record) => record.message.toLowerCase().includes(value.toLowerCase()),
          fixed: 'right',
        },
        {
          title: 'วันที่สร้าง',
          key: 'createdAt',
          dataIndex: 'createdAt',
          width: 250,
          customRender: (text, row, index) => {
            return moment(text).format('DD/MM/YYYY HH:mm:ss')
          },
          onFilter: (value, record) => record.createdAt.toLowerCase().includes(value.toLowerCase()),
          fixed: 'right',
        },

      ],
    }
  },
  methods: {
    async getDataSMS() {
      const dataSMS = await {
        startDate: this.getStartDate,
        endDate: this.getEndDate,
        operatorCode: this.getSelectOperator,
        bankSetId: this.getSelectBankSet,
      }

      await apiClient.post('/smsPull/getData', dataSMS).then(response => {
        const res = response.data
        if (res.code === '000') {
          this.data = res.responseData.data
          if (this.data.length > 0) {
            const listOperater = this.data.map(function(item, pos) {
              return { text: item.operatorName, value: item.operatorName }
            })
            this.columns[1].filters = [
              ...new Map(listOperater.map((item) => [item.text, item])).values(),
            ]
          }
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error.message}`,
        )
      })
    },
    refreshData() {
      this.loading(true)
      this.getDataSMS()
      this.loading(false)
    },
    async loading(e) {
      if (e) {
        Swal.fire({
          title: 'กำลังตรวจสอบ',
          text: 'ระบบกำลังตรวจสอบข้อมูล กรุณารอสักครู่.',
          showConfirmButton: false,
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })
      } else {
        Swal.close()
      }
    },
  },
  async created() {
    // await this.getDataSMS()
  },
}
</script>

<style>

</style>
